<script setup lang="tsx">
import type { MenuGroupOption, MenuOption } from "naive-ui"
import { NEllipsis, NIcon } from "naive-ui"
import {
    DocumentTextOutline,
    HomeOutline,
    GiftOutline,
    PersonOutline,
    NavigateCircleOutline,
    DocumentsOutline,
    SettingsOutline,
    ColorPaletteOutline,
    ImagesOutline,
    SearchSharp,
    CartOutline,
} from "@vicons/ionicons5"
import { ShoppingBagOutlined } from "@vicons/material"

const router = useRouter()
const value = ref()
const { t } = useI18n()

watch(
    () => router.currentRoute.value.name,
    (v) => {
        value.value = v
    },
    {
        immediate: true,
    },
)

const collapsed = ref(false)

function renderIcon(icon: Component) {
    return () => h(NIcon, null, { default: () => h(icon) })
}

function onChangeValue(v: string) {
    router.push({ name: v })
    // router.push({ name: v })
}

const menuOptions: MenuOption[] = [
    {
        label: () => t("ly-diy-00003"),
        key: "pages",
        icon: renderIcon(DocumentTextOutline),
        children: [
            {
                label: () => t("ly-diy-00004"),
                key: "diy-page",
                icon: renderIcon(HomeOutline),
            },
            {
                label: () => t("ly-diy-00005"),
                key: "diy-page-search",
                icon: renderIcon(SearchSharp),
            },
            // {
            //     label: () => t("ly-diy-00007"),
            //     key: "diy-page-cart",
            //     icon: renderIcon(CartOutline),
            // },
            {
                label: () => t("ly-diy-00008"),
                key: "diy-page-person",
                icon: renderIcon(PersonOutline),
            },
        ],
    },
    {
        label: () => t("ly-diy-00011"),
        key: "settings",
        icon: renderIcon(SettingsOutline),
        children: [
            {
                label: () => t("ly-diy-00010"),
                key: "diy-template",
                icon: renderIcon(DocumentsOutline),
            },
            {
                label: () => t("LDIY01133"),
                key: "diy-setting-recommend",
                icon: renderIcon(ShoppingBagOutlined),
            },
            {
                label: () => t("LDIY01419"),
                key: "diy-setting-pages",
                icon: renderIcon(DocumentTextOutline),
            },
            // {
            //     label: () => t("ly-diy-00012"),
            //     key: "diy-setting-theme",
            //     icon: renderIcon(ColorPaletteOutline),
            // },
            // {
            //     label: () => t("ly-diy-00013"),
            //     key: "diy-setting-empty",
            //     icon: renderIcon(ImagesOutline),
            // },
            // {
            //     label: () => t("ly-diy-00014"),
            //     key: "diy-setting-material",
            //     icon: renderIcon(ImagesOutline),
            // },
            // {
            //     label: () => t("ly-diy-00015"),
            //     key: "diy-setting-desc",
            //     icon: renderIcon(DocumentTextOutline),
            // },
        ],
    },
    {
        label: () => t("ly-diy-00016"),
        key: "diy-material",
        icon: renderIcon(ImagesOutline),
    },
]

const windowResize = () => {
    if (window.innerWidth <= 1440) {
        width.value = 160
        iconSize.value = 16
        indent.value = 16
    } else {
        width.value = 200
        iconSize.value = 18
        indent.value = 24
    }
}

const width = ref(200)
const iconSize = ref(20)
const indent = ref(24)

onMounted(() => {
    windowResize()
    window.addEventListener("resize", windowResize)
})

onUnmounted(() => {
    window.removeEventListener("resize", windowResize)
})

const renderLabel = (option: any) => {
    return (
        <NEllipsis>
            <span>{typeof option.label === "string" ? option.label : option.label()}</span>
        </NEllipsis>
    )
}
</script>

<template>
    <NLayoutSider
        bordered
        collapse-mode="width"
        :width="width"
        :collapsed="collapsed"
        show-trigger
        @collapse="collapsed = true"
        @expand="collapsed = false"
    >
        <NMenu
            class="menu"
            default-expand-all
            :icon-size="iconSize"
            :indent="indent"
            :value="value"
            :collapsed="collapsed"
            :options="menuOptions"
            :render-label="renderLabel"
            @update:value="onChangeValue"
        />
    </NLayoutSider>
</template>

<style lang="scss" scoped>
.menu {
    font-size: 13px;
    // 响应式
    @media only screen and (max-width: 1440px) {
        font-size: 12px;
    }
}
</style>
